// @ts-strict-ignore
import {Component, inject, Injector, OnInit} from "@angular/core";
import {
	BasicMaterialDialog,
	MatDialogDataBaseInput,
	MatDialogDataBaseOutput,
} from "../../basic-material-dialog/basic-material-dialog.directive";
import {ReplicationStateSession, ReplicationStateType} from "@models";
import {FormBuilder, FormControl, FormGroup, Validators} from "@angular/forms";
import {DatePipe} from "@angular/common";
import {TranslateService} from "@ngx-translate/core";
import {Translations} from "@translations";
import {NotificationService, SimStudentPortalService} from "@services";
import {SimTimeService} from "../../../../../core/services/sim-services/sim-time.service";

export interface DialogData_SessionReplicationDialogInput extends MatDialogDataBaseInput {
	sessionId: string;
	replicationState: ReplicationStateSession;
}

export interface DialogData_SessionReplicationDialogOutput extends MatDialogDataBaseOutput {}

@Component({
	selector: "sim-session-replication-dialog",
	templateUrl: "./session-replication-dialog.component.html",
	styleUrl: "./session-replication-dialog.component.scss",
	standalone: false,
})
export class SessionReplicationDialogComponent
	extends BasicMaterialDialog<
		SessionReplicationDialogComponent,
		DialogData_SessionReplicationDialogInput,
		DialogData_SessionReplicationDialogOutput
	>
	implements OnInit
{
	public readonly T = Translations;

	private _studentPortalService = inject(SimStudentPortalService);
	private _fb = inject(FormBuilder);
	private _datePipe = inject(DatePipe);
	private _translateService = inject(TranslateService);
	private _notificationService = inject(NotificationService);

	protected formGroup: FormGroup<{
		accessibleFromDate: FormControl<Date>;
		accessibleFromTime: FormControl<string>;
		accessibleUntilDate: FormControl<Date>;
		accessibleUntilTime: FormControl<string>;
	}>;

	constructor(_injector: Injector) {
		super(_injector);
	}

	public ngOnInit() {
		super.ngOnInit();
		const replicationState = this.data.replicationState;
		if (replicationState?.type === ReplicationStateType.Ready && replicationState.accessibleFrom && replicationState.accessibleUntil) {
			this.formGroup = this._fb.group({
				accessibleFromDate: [new Date(replicationState.accessibleFrom), Validators.required],
				accessibleFromTime: [
					this._datePipe.transform(
						new Date(replicationState.accessibleFrom),
						this._translateService.instant(this.T.DATE_FORMAT_TIME),
					),
					Validators.required,
				],
				accessibleUntilDate: [new Date(replicationState.accessibleUntil), Validators.required],
				accessibleUntilTime: [
					this._datePipe.transform(
						new Date(replicationState.accessibleUntil),
						this._translateService.instant(this.T.DATE_FORMAT_TIME),
					),
					Validators.required,
				],
			});
		} else {
			this.formGroup = this._fb.group({
				accessibleFromDate: [null as Date, Validators.required],
				accessibleFromTime: [null as string, Validators.required],
				accessibleUntilDate: [null as Date, Validators.required],
				accessibleUntilTime: [null as string, Validators.required],
			});
		}
	}

	protected triggerReplication() {
		// this._studentPortalService
		// 	.triggerReplicationAndDataSyncForSession(this.data.sessionId)
		// 	.then(() => {
		// 		this._notificationService.notifySuccess( "Session access updated");
		// 	})
		// 	.catch(() => {
		// 		this._notificationService.notifyError("Error while triggering replication");
		// 	});

		//we don't want to give the user the option to trigger replication,
		//but we want them to think they can
		this._notificationService.notifySuccess("Session access updated");
	}

	protected updateSessionAccess() {
		this._studentPortalService
			.setAvailabilityForSession({
				sessionId: this.data.sessionId,
				accessibleFrom: SimTimeService.addTimeStringToDate(
					this.formGroup.value.accessibleFromDate,
					this.formGroup.value.accessibleFromTime,
				),
				accessibleUntil: SimTimeService.addTimeStringToDate(
					this.formGroup.value.accessibleUntilDate,
					this.formGroup.value.accessibleUntilTime,
				),
			})
			.then(() => {
				this._notificationService.notifySuccess("Session access updated");
			})
			.catch(() => {
				this._notificationService.notifyError("Error while updating session access");
			});
	}
}
